import probasePaymentsList from './probasePaymentsList.js';

export default {
    list: probasePaymentsList
}